module.exports = __webpack_public_path__ + "img/background_c3-1-1.384517c1.png";